import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
// import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import Menu from './modules/menu'

import Faq from './modules/faq'
import editorJS from './modules/editorJS'
import globalAnimation from './animation/globalAnimation'
import LenisScroll from './animation/lenis'
import contatoForm from './modules/fale_conosco'

// Init
GLOBAL.DesignSystem = DesignSystem({})
// register() // Swiper Web Component

// new Swiper('.swiper-banner-logos', {
// 	slidesPerView: 'auto',
// })
// Config
console.log('31/10 deploy novo. partytown 2')
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)

Menu()
LenisScroll()
contatoForm()

UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()

editorJS()

Faq()

// Pages
PageHome()
PageLogin()?.init()

// utils logs
logs()

// document.addEventListener('DOMContentLoaded', ()=>{})
animaAoScroll()
globalAnimation()

Fancybox.bind('[data-fancybox]', {
	on: {
		done: (fancybox, slide) => {
			// Espera até o conteúdo estar disponível
			// const iframe = slide.$content?.querySelector('iframe')
			// if (iframe && iframe.src.includes('vimeo.com')) {
			// 	// Manda comando play via postMessage
			// 	iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*')
			// 	console.log('play ?')
			// }
		},
	},
})

function enableAutoplayVideos(selector = '.autoplay-video') {
	document.querySelectorAll(selector).forEach((video) => {
		// Força as configurações necessárias
		video.muted = true
		video.playsInline = true

		// Tenta tocar o vídeo
		const playPromise = video.play()

		if (playPromise !== undefined) {
			playPromise.catch((error) => {
				console.warn('Autoplay falhou para um vídeo:', error)
				// Você pode adicionar lógica aqui, como exibir um botão de "tocar"
			})
		}
	})
}

function menuSpan() {
	const items = document.querySelectorAll('.dropdown li a')

	if (!items && items.length === 0) return
	items.forEach((link, index) => {
		const text = link.textContent.trim()
		const parts = text.split(' - ')

		if (parts.length >= 2) {
			const firstPart = parts[0]
			const middleParts = parts.slice(1, -1).join(' - ')
			const lastPart = parts[parts.length - 1]

			link.innerHTML =
				`<span class="pre-dash">${firstPart}</span>` +
				(middleParts ? ` - ${middleParts}` : '') +
				` - <span class="post-dash">${lastPart}</span>`

			// Adiciona uma classe única opcional para cor
			link.classList.add(`color-${index + 1}`)
		}
	})
}

document.addEventListener('DOMContentLoaded', function () {
	const lazyVideos = document.querySelectorAll('video.lazy-video')
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

	lazyVideos.forEach((video) => {
		const dataSrc = video.dataset.src
		if (!dataSrc) return

		if (!isIOS) {
			// ANDROID/DESKTOP: bloqueia o carregamento imediato
			video.pause()
			video.removeAttribute('src')
			video.load() // força cancelamento

			// Observer para ativar quando entra na viewport
			const observer = new IntersectionObserver(
				(entries, obs) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							video.src = dataSrc
							video.muted = true
							video.setAttribute('playsinline', '')
							video.autoplay = true
							video.load()

							setTimeout(() => {
								const playPromise = video.play()
								if (playPromise !== undefined) {
									playPromise.catch((err) => console.warn('Erro no autoplay:', err))
								}
							}, 100)

							obs.unobserve(video)
						}
					})
				},
				{
					rootMargin: '200px',
					threshold: 0.1,
				}
			)
			observer.observe(video)
		}
		// iOS: não faz nada, deixa carregar automaticamente
	})
})

document.addEventListener('DOMContentLoaded', () => {
	enableAutoplayVideos() // Ativa para todos os vídeos com a classe .autoplay-video
	menuSpan()
})
